/**
 * @file Defines the {@link LANG_INTERFACE} constant
 * @author Joe Thompson <joe.thompson@1x2gaming.com>
 */

/**
 * Object for all texts in interfaces
 * @type {object}
 * @constant
 * @default
 */

 const LANG_INTERFACE = {

   autospin: {

    'autospin-header-text':        'Autoplay', //TODO: ask fab if possible to have translation for 'Autoplay'
    'autospin-title':              'Stop Autoplay',
    'if-cash-increase-label-name': 'If cash increase by ',
    'if-cash-decrease-label-name': 'If cash decrease by ',
    'on-any-win-label-name':       'On any win ',
    'on-feature-label-name':       'When entering any feature',
    'on-single-win-label-name':    'On single win of '

   },
   
   bet: {
    'bet-header-text': 'Bet:'
   }

 }

 export { LANG_INTERFACE }